import { z } from 'zod'

export const schema = z.object({
  input_type: z.union([z.literal('attributions'), z.literal('schedule'), z.literal('jpm')]),
  files: z.instanceof(FileList).refine((list) => list.length > 0),
})

export type SchemaType = z.infer<typeof schema>
